export class TokenValidator {
    static parseJwt = (token: string): Record<string, string | number> | null => {
        if (token) {
            return JSON.parse(atob(token.split('.')[1]))
        } else {
            return null
        }
    }

    static isValidTokenDate = (token: string): boolean => {
    if (token && typeof token === 'string') {
        const parts = token.split('.')

        if (parts.length !== 3) {
            return false
        }
        const [header, payload, signature] = parts

        if (!header || !payload || !signature) {
            return false
        }

        const now = Math.floor(Date.now() / 1000)
        const tokenExp = this.parseJwt(token)?.exp
        return typeof tokenExp === 'number' && tokenExp > now
    }
    return false
    }
}